
import {isEmpty, map} from 'lodash';

import {DASHBOARD_SEARCH_CRITERIA_KEYS} from '../charts-and-grids/charts-util.js';
import {
    getTransformedAdvancedPurchaseGroupingList,
    getTransformedAnalystApproversList,
    getTransformedBenchmarkCarriersList,
    getTransformedCabinList,
    getTransformedFareBrandsForHostCarrierList,
    getTransformedFareTypeList,
    getTransformedMarketDestinationList,
    getTransformedMarketList,
    getTransformedMarketOriginList,
    getTransformedMarketTierList,
    getTransformedMaxStayGroupsList,
    getTransformedMinStayGroupsList,
    getTransformedPOSList,
    getTransformedRbdsList,
    getTransformedRegionsList,
    getTransformedSeasonsList
} from '../app-configs-util/app-configs-util.js';
import {getClonedObject} from '../../../utils/common-util.js';
import {DateUtil} from '../../../utils/date-util.js';
import {DASHBOARD_TOP_TABS_VALUE, URL_SAVE_CRITERIA_CONTEXT_ID} from '../../../utils/constants.js';

export const PICKUP_OPTIONS_FROM_KEY = 'pickOptionsFrom';

export const SELECTED_VALUE_KEY = 'selectedValue';
export const SELECTED_VALUES_KEY = 'selectedValues';
export const IS_ERROR_KEY = 'isError';
export const ALL_OPTIONS_KEY = 'allOptions';
export const TITLE_KEY = 'title';
export const CRITERIA_CATEGORY_AGGREGATION_DATE = 'criteriaCategoryAggregationDate';

export const getDefaultStartEndDate = (format, startDate, endDate) => {
    const start = isEmpty(startDate) ? DateUtil.formatDate(DateUtil.subtractDaysInMoment(DateUtil.getNowMoment(), 6).toDate(), format) : DateUtil.formatDate(startDate, format);
    const end = isEmpty(endDate) ? DateUtil.formatDate(DateUtil.getNowMoment().toDate(), format) : DateUtil.formatDate(endDate, format);

    return {
        start: start,
        end: end
    };
};

export const dashboardSearchCriteriaModalConfig = (criteria, recommCompetitor) => {
    const DDSCK = DASHBOARD_SEARCH_CRITERIA_KEYS;
    const searchCriteriaModalConfig = {
        [DDSCK.CRITERIA_CATEGORY]: getDashboardCriteriaCategoryBasedOnRecommCompetitor(recommCompetitor),
        [DDSCK.CRITERIA_LOCATION]: getDashboardCriteriaLocationBasedOnRecommCompetitor(recommCompetitor),
        [DDSCK.CRITERIA_MARKET_TIER]: [
            {label: 'Market Tier', value: DDSCK.CRITERIA_MARKET_TIER}
        ],
        [DDSCK.CRITERIA_CABIN_CODE]: [
            {label: 'Cabin Code', value: DDSCK.CRITERIA_CABIN_CODE}
        ],
        [DDSCK.CRITERIA_BENCHMARK_CARRIER]: [
            {label: 'BenchMark Carrier', value: DDSCK.CRITERIA_BENCHMARK_CARRIER}
        ],
        [DDSCK.CRITERIA_FARE_TYPE]: [
            {label: 'Fare Type', value: DDSCK.CRITERIA_FARE_TYPE}
        ],
        [DDSCK.CRITERIA_MIN_MAX_GROUP]: [
            {label: 'Min stay group', value: DDSCK.CRITERIA_MIN_GROUP},
            {label: 'Max stay group', value: DDSCK.CRITERIA_MAX_GROUP}
        ],
        [DDSCK.CRITERIA_ADVANCE_PURCHASE_GROUP]: [
            {label: 'Advance purchase group', value: DDSCK.CRITERIA_ADVANCE_PURCHASE_GROUP}
        ],
        [DDSCK.CRITERIA_RBD]: [
            {label: 'RBD', value: DDSCK.CRITERIA_RBD}
        ],
        [DDSCK.CRITERIA_FARE_BRAND]: [
            {label: 'Fare Brand', value: DDSCK.CRITERIA_FARE_BRAND}
        ],
        [DDSCK.CRITERIA_ANALYST]: [
            {label: 'Analyst', value: DDSCK.CRITERIA_ANALYST}
        ],
        [DDSCK.CRITERIA_SEASON]: [
            {label: 'Season', value: DDSCK.CRITERIA_SEASON}
        ]
    };

    return searchCriteriaModalConfig[criteria];
};

const getDashboardCriteriaCategoryBasedOnRecommCompetitor = (recommCompetitor) => {
    const DDSCK = DASHBOARD_SEARCH_CRITERIA_KEYS;
    return (recommCompetitor === DASHBOARD_TOP_TABS_VALUE.RECOMMENDATION) ? [
        {label: 'Location', value: DDSCK.CRITERIA_LOCATION},
        {label: 'Market Tier', value: DDSCK.CRITERIA_MARKET_TIER},
        {label: 'Cabin', value: DDSCK.CRITERIA_CABIN_CODE},
        {label: 'Analyst', value: DDSCK.CRITERIA_ANALYST}
    ] : [
        {label: 'Location', value: DDSCK.CRITERIA_LOCATION},
        {label: 'Cabin', value: DDSCK.CRITERIA_CABIN_CODE},
        {label: 'BenchMark Carrier', value: DDSCK.CRITERIA_BENCHMARK_CARRIER},
        {label: 'Fare Type', value: DDSCK.CRITERIA_FARE_TYPE},
        {label: 'RBD', value: DDSCK.CRITERIA_RBD},
        {label: 'Season', value: DDSCK.CRITERIA_SEASON}
    ]
};

const getDashboardCriteriaLocationBasedOnRecommCompetitor = (recommCompetitor) => {
    const DDSCK = DASHBOARD_SEARCH_CRITERIA_KEYS;
    return (recommCompetitor === DASHBOARD_TOP_TABS_VALUE.RECOMMENDATION) ? [
        {label: 'Market', value: DDSCK.CRITERIA_MARKET},
        {label: 'POS', value: DDSCK.CRITERIA_POS},
        {label: 'Market Origin', value: DDSCK.CRITERIA_MARKET_ORIGIN},
        {label: 'Market Destination', value: DDSCK.CRITERIA_MARKET_DESTINATION},
        {label: 'Region', value: DDSCK.CRITERIA_REGION}
    ] : [
        {label: 'Market', value: DDSCK.CRITERIA_MARKET},
        {label: 'POS', value: DDSCK.CRITERIA_POS},
        {label: 'Market Origin', value: DDSCK.CRITERIA_MARKET_ORIGIN},
        {label: 'Market Destination', value: DDSCK.CRITERIA_MARKET_DESTINATION}
    ]
};

export const OPERATOR_OPTIONS = [
    {label: '=', value: '=='},
    {label: '!=', value: '!='}
];

export const getLabelValuePairFromConfig = (appConfig, configName) => {
    let options;

    switch (configName) {
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_ANALYST:
            options = getTransformedAnalystApproversList(appConfig);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_REGION:
            options = getTransformedRegionsList(appConfig);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_FARE_BRAND:
            options = getTransformedFareBrandsForHostCarrierList(appConfig);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_ADVANCE_PURCHASE_GROUP:
            options = getTransformedAdvancedPurchaseGroupingList(appConfig);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_MIN_GROUP:
            options = getTransformedMinStayGroupsList(appConfig);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_MAX_GROUP:
            options = getTransformedMaxStayGroupsList(appConfig);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_MARKET:
            options = getTransformedMarketList(appConfig);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_MARKET_TIER:
            options = getTransformedMarketTierList(appConfig);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_FARE_TYPE:
            options = getTransformedFareTypeList();
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_MARKET_ORIGIN:
            options = getTransformedMarketOriginList(appConfig);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_MARKET_DESTINATION:
            options = getTransformedMarketDestinationList(appConfig);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_RBD:
            options = getTransformedRbdsList(appConfig);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_BENCHMARK_CARRIER:
            options = getTransformedBenchmarkCarriersList(appConfig, true);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_POS:
            options = getTransformedPOSList(appConfig);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_CABIN_CODE:
            options = getTransformedCabinList(appConfig);
            break;
        case DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_SEASON:
            options = getTransformedSeasonsList(appConfig, {isConcatAbbreviation: true, isShowNoSeason: true});
            break;
        default:
            options = [{label: '', value: ''}];
    }

    return options;
};

export const getDefaultSearchCriteria = () => getClonedObject({
    criteriaCategory: {
        pickOptionsFrom: DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_CATEGORY,
        selectedValue: DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_LOCATION
    },
    criteriaName: {
        pickOptionsFrom: DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_LOCATION,
        selectedValue: DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_MARKET
    },
    criteriaOperator: OPERATOR_OPTIONS[0].value,
    criteriaValue: {
        pickOptionsFrom: DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_MARKET,
        selectedValues: [],
        isError: false
    }
});

export const updateAndGetSearchCriteria = (changed, addedSearchCriteria, rowIndex, selectedValue, criteriaName, allOptions) => {
    const updatedCriteria = getClonedObject(addedSearchCriteria[rowIndex]);
    updatedCriteria.criteriaValue.isError = false;

    switch (changed) {
        case 'criteriaCategory':
            updatedCriteria.criteriaCategory.selectedValue = selectedValue;
            updatedCriteria.criteriaName.pickOptionsFrom = selectedValue;
            updatedCriteria.criteriaName.selectedValue = criteriaName;
            updatedCriteria.criteriaValue.pickOptionsFrom = criteriaName;
            updatedCriteria.criteriaValue.selectedValues = [];
            break;
        case 'criteriaName':
            updatedCriteria.criteriaName.selectedValue = selectedValue;
            updatedCriteria.criteriaValue.pickOptionsFrom = selectedValue;
            updatedCriteria.criteriaValue.selectedValues = [];
            break;
        case 'criteriaOperator':
            updatedCriteria.criteriaOperator = selectedValue;
            break;
        case 'criteriaValue':
            updatedCriteria.criteriaValue.selectedValues = selectedValue;
            updatedCriteria.criteriaValue.allOptions = allOptions;
            updatedCriteria.criteriaValue.isError = isEmpty(selectedValue);
            break;
    }

    return [...addedSearchCriteria.slice(0, rowIndex), {...updatedCriteria}, ...addedSearchCriteria.slice(rowIndex + 1)];
};

export const transformAddedRows = (saveSearchCriteriaText, searchCriteriaDetails, startEndDate, userId, recommCompetitor) => {
    const transformedData = {
        value: {
            rules: []
        }
    }
    transformedData.userId = userId;
    transformedData.contextId = `${URL_SAVE_CRITERIA_CONTEXT_ID}-${recommCompetitor}`;
    transformedData.title = saveSearchCriteriaText;

    map(searchCriteriaDetails, eachSearchCriteriaDetails => {
        transformedData.value.rules.push(transformRows(eachSearchCriteriaDetails));
    });
    transformedData.value.rules.push(transformDates(startEndDate));

    return transformedData;
}

const transformRows = (eachSearchCriteriaDetails) => {
    let rules = {
        category: '',
        criterion: '',
        operator: '',
        leftOperand: [],
        rightOperand: [],
    };
    rules.category = eachSearchCriteriaDetails.criteriaCategory.selectedValue;
    rules.criterion = eachSearchCriteriaDetails.criteriaName.selectedValue;
    rules.operator = (eachSearchCriteriaDetails.criteriaOperator === '==' ? '=' : eachSearchCriteriaDetails.criteriaOperator);
    rules.leftOperand = map(eachSearchCriteriaDetails.criteriaValue.selectedValues, eachValue => {
        return eachValue.value;
    });
    return rules;
}

const transformDates = (startEndDate) => {
    let rules = {
        category: '',
        criterion: '',
        operator: '',
        leftOperand: [],
        rightOperand: [],
    };
    rules.category = DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_AGGREGATION_DATE;
    rules.criterion = DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_AGGREGATION_DATE;
    rules.operator = '<';
    rules.leftOperand = startEndDate.start;
    rules.rightOperand = startEndDate.end;
    return rules;
}
